import { cn } from '../../lib/utils';
import campaignDefault from '../../assets/campaign_default.png';
interface Campaign {
  campaignId: string;
  campaignImageUrl: string;
  title: string;
  description: string;
}

export default function CampaignCard({
  campaign,
  className
}: Readonly<{
  campaign: Campaign;
  className?: string;
}>) {
  return (
    <div
      className={cn(
        'h-full w-48 overflow-hidden rounded-2xl bg-white shadow-lg drop-shadow-lg',
        className
      )}
    >
      <div className="relative flex h-24 w-full items-center justify-center p-0">
        <img
          src={campaign.campaignImageUrl || campaignDefault}
          className="absolute inset-0 aspect-video h-full w-full"
          alt={campaign.title}
          onError={(e) => {
            e.currentTarget.onerror = null;
            e.currentTarget.src = campaignDefault;
          }}
        />
      </div>
      <div className="flex flex-col items-center space-y-4 p-3 pb-4 text-start text-xs font-semibold">
        <p className="line-clamp-2 font-semibold">{campaign.title}</p>
      </div>
    </div>
  );
}
